import axios from "axios";
import { isProd } from "../constants";

const headers = {
  pragma: "no-cache",
  "cache-control": "no-cache",
};

export const get = (endpoint) => {
  console.log("getting endpoint", endpoint);

  var url = endpoint;
  var useCredentials = false;
  if (url.includes("data") && isProd) {
    useCredentials = true;
  }

  if (useCredentials) {
    return axios.get(endpoint, {
      headers,
      withCredentials: true,
      auth: {
        username: "sch",
        password: "awlkdjawldj32l3d3lakdalkjdawa",
      },
    });
  }
  return axios.get(endpoint, { headers });
};
